// Roteamento por hash (`#/conversas?id=VT-2841`), como no bus-observer: o CloudFront só
// precisa servir o index.html, e o link de um atendimento pode ser copiado e colado.
import { useSyncExternalStore } from "react";

export interface HashLocation {
  slug: string;
  params: URLSearchParams;
}

export function parseHash(hash: string): HashLocation {
  const raw = hash.replace(/^#\/?/, "");
  const [path, query = ""] = raw.split("?");
  return { slug: decodeURIComponent(path ?? ""), params: new URLSearchParams(query) };
}

const subscribe = (cb: () => void) => {
  window.addEventListener("hashchange", cb);
  return () => window.removeEventListener("hashchange", cb);
};

export function useHashLocation(): HashLocation {
  const hash = useSyncExternalStore(subscribe, () => window.location.hash);
  return parseHash(hash);
}

export function hrefTo(slug: string, params?: Record<string, string>) {
  const q = params ? new URLSearchParams(params).toString() : "";
  return `#/${slug}${q ? `?${q}` : ""}`;
}

export function navigate(slug: string, params?: Record<string, string>) {
  const next = hrefTo(slug, params);
  if (window.location.hash !== next) window.location.hash = next;
  window.scrollTo(0, 0);
}

/** Troca só os parâmetros da tela atual, sem rolar nem empilhar histórico. */
export function setHashParams(params: Record<string, string | undefined>) {
  const { slug, params: current } = parseHash(window.location.hash);
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === "") current.delete(k);
    else current.set(k, v);
  }
  const q = current.toString();
  history.replaceState(null, "", `#/${slug}${q ? `?${q}` : ""}`);
  window.dispatchEvent(new HashChangeEvent("hashchange"));
}
